export const uk = {
    error: 'С ошибкой',
    new: 'Новый',
    processing: 'В обработке',
    ready: 'Готов'
};
